import { containsObject } from "../arrayOperations";
import { ROLE_ADMIN, ROLE_EDITOR, ROLE_OWNER, USER_ROLES } from "@/constant";
/**
 * Checks if user has a role
 */
export const hasRole = (userItem, organizationRole) => {
  if (userItem?.permissions) {
    return containsObject(organizationRole, userItem?.permissions, "@id");
  } else if (userItem?.organizationPermissions) {
    return containsObject(organizationRole, userItem?.organizationPermissions, "@id");
  }

  return false;
};

/**
 * Finds and returns role information
 */
export const getRoleInfo = role => {
  return USER_ROLES.find(obj => {
    return obj.value === role.name;
  });
};

/**
 * As of right now, users might have multiple roles assigned to them;
 * Currently, the roles are hierarchical, meaning that:
 * Admin can do whatever the Editor can do, and Owner can do whatever the Admin can do
 * Owner -> Admin -> Editor
 * Function returns the role that has the most permissions
 * @function getMainRole
 * @param {Array} roles - 'organizationPermissions' array of user
 * @returns {Record<string, string> | Undefined}
 */
export const getMainRole = roles => {
  if (!roles || !roles.length) return;
  const uniqueRoles = [...new Set(roles.map(item => item.name))];
  // Order of IFs matters here
  if (uniqueRoles.includes(ROLE_OWNER.value)) return roles.find(role => role.name === ROLE_OWNER.value);
  if (uniqueRoles.includes(ROLE_ADMIN.value)) return roles.find(role => role.name === ROLE_ADMIN.value);
  if (uniqueRoles.includes(ROLE_EDITOR.value)) return roles.find(role => role.name === ROLE_EDITOR.value);

  return;
};

export const userIsOwner = organizationPermissions => {
  return getMainRole(organizationPermissions)?.name === ROLE_OWNER.value;
};

export const userIsEditor = organizationPermissions => {
  return getMainRole(organizationPermissions)?.name == ROLE_EDITOR.value;
};
